interface CsvOptions {
  headers: string[]
  rows: (string | number | boolean | null | undefined)[][]
}

export const buildCsvContent = ({ headers, rows }: CsvOptions): string => {
  const escapedRows = [headers, ...rows].map((row) =>
    row
      .map((cell) => {
        if (cell === null || cell === undefined) {
          return ""
        }
        const value = String(cell)
        return value.includes('"') ||
          value.includes(",") ||
          value.includes("\n")
          ? `"${value.replace(/"/g, '""')}"`
          : value
      })
      .join(","),
  )

  return escapedRows.join("\n")
}

export const downloadCsv = (filename: string, content: string) => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
